import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, Phone, X } from 'lucide-react'
import Container from './Container'
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL, NAV_ITEMS, SOCIAL_LINKS } from '@/lib/constants'
import { cn } from '@/lib/utils'

function TelegramIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <path
        fill="currentColor"
        d="M20.7 4.3c.7-.3 1.4.3 1.2 1.1l-3 15.6c-.2.9-1.2 1.3-2 .8l-4.8-3.5-2.3 2.2c-.4.4-1.1.2-1.2-.4l-.9-5.1 11.1-9.8c.3-.2 0-.6-.3-.4L6.2 12l-4.5-1.4c-.9-.3-.9-1.6 0-1.9l19-7.4Z"
      />
    </svg>
  )
}

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <Container>
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold text-gray-800">Business Mall</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-1">
            {NAV_ITEMS.map((item) => {
              const isActive = location.pathname === item.path
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={cn(
                    'px-4 py-2 rounded-lg text-sm font-medium transition-all duration-default ease-smooth',
                    isActive
                      ? 'bg-warm-gray-50 text-gray-800'
                      : 'text-gray-600 hover:bg-warm-gray-50 hover:text-gray-800'
                  )}
                >
                  {item.label}
                </Link>
              )
            })}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <a
              href={`tel:${CONTACT_PHONE_TEL}`}
              className="inline-flex items-center gap-2 rounded-lg bg-warm-gray-50 hover:bg-warm-amber-50 border border-black/5 px-3 py-2 text-sm font-semibold text-gray-900 transition-colors"
              title="Позвонить"
            >
              <Phone className="h-4 w-4 text-secondary" />
              <span>{CONTACT_PHONE_DISPLAY}</span>
            </a>

            <a
              href={SOCIAL_LINKS.telegram}
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Telegram"
              className="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/70 hover:bg-warm-gray-50 border border-black/5 text-gray-700 hover:text-gray-900 transition-colors"
              title="Telegram"
            >
              <TelegramIcon className="h-5 w-5" />
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-warm-gray-50 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-800" />
            ) : (
              <Menu className="h-6 w-6 text-gray-800" />
            )}
          </button>
        </div>
      </Container>

      
        {mobileMenuOpen && (
          <div
            className="md:hidden border-t border-gray-200 bg-white"
          >
            <Container>
              <nav className="py-4 space-y-1">
                {NAV_ITEMS.map((item) => {
                  const isActive = location.pathname === item.path
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className={cn(
                        'block px-4 py-2 rounded-lg text-sm font-medium transition-colors',
                        isActive
                          ? 'bg-warm-gray-50 text-gray-800'
                          : 'text-gray-600 hover:bg-warm-gray-50'
                      )}
                    >
                      {item.label}
                    </Link>
                  )
                })}
              </nav>

              <div className="pb-5 pt-3 border-t border-gray-100 mt-3 flex items-center justify-between gap-3">
                <a
                  href={`tel:${CONTACT_PHONE_TEL}`}
                  className="inline-flex items-center gap-2 rounded-lg bg-warm-gray-50 hover:bg-warm-amber-50 border border-black/5 px-3 py-2 text-sm font-semibold text-gray-900 transition-colors"
                >
                  <Phone className="h-4 w-4 text-secondary" />
                  <span>{CONTACT_PHONE_DISPLAY}</span>
                </a>
                <div className="flex items-center gap-2">
                  <a
                    href={SOCIAL_LINKS.telegram}
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label="Telegram"
                    className="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/70 hover:bg-warm-gray-50 border border-black/5 text-gray-700 hover:text-gray-900 transition-colors"
                    title="Telegram"
                  >
                    <TelegramIcon className="h-5 w-5" />
                  </a>
                </div>
              </div>
            </Container>
          </div>
        )}
      
    </header>
  )
}
